<template>
  <div class="irp-master-tab" data-testid="irp-master-tab">
    <h3 class="irp-master-tab__heading">{{ detailsHeading }}</h3>
    <IRPFieldGrid :fields="ownFields" />
    <IRPFieldGrid
      v-for="(owner, index) in accountOwners"
      :key="`owner_${index}`"
      :fields="owner.fields"
    />
    <IRPPartnerFilterBar
      :key="`${individualRecordStore.sourceId}_${individualRecordStore.sourcePrimaryKey}`"
      section="master"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';

import { useIndividualRecordStore } from '@/stores';
import type {
  RecordCollectionType,
  RecordFieldType,
} from '@/types/individual_record';

import IRPFieldGrid from './IRPFieldGrid.vue';
import IRPPartnerFilterBar from './IRPPartnerFilterBar.vue';

const individualRecordStore = useIndividualRecordStore();

const detailsHeading = computed(() =>
  individualRecordStore.mdmType === 'lead' ? 'Lead details' : 'Account details',
);

const ownFields = computed<RecordFieldType[]>(
  () => individualRecordStore.master?.own?.fields ?? [],
);

const accountOwners = computed(
  () =>
    (
      individualRecordStore.master?.own?.account_owners as
        | RecordCollectionType
        | undefined
    )?.items ?? [],
);

watch(
  () =>
    [
      individualRecordStore.sourceId,
      individualRecordStore.sourcePrimaryKey,
    ] as const,
  () => individualRecordStore.fetchSection('master'),
  { immediate: true },
);
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";
.irp-master-tab {
  @apply flex flex-col gap-16;
}

.irp-master-tab__heading {
  @apply text-base font-bold text-neutral-text-strong;
}
</style>
